import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import TaskItem from '../TaskItem'
import { open as openInterstitialAction } from 'components/QuestionnaireRequestAutomated/processor/slices/interstitialSlice'

export default function SignTask({ disabled = false }) {
  const dispatch = useDispatch()
  const openInterstitial = useCallback(() => dispatch(openInterstitialAction()), [dispatch])

  return (
    <TaskItem
      disabled={disabled}
      title="signature"
      subTitle="none"
      btnTitle="open"
      iconClassName="fa-light fa-signature"
      onSubmit={openInterstitial}
    />
  )
}
